import { createTheme } from '@mui/material'
// import { COLOR_SCHEMES, useColorScheme } from '../contexts/ColorSchemeContext'
import { useWindowDimensions } from 'react-native-web'
import { coalesce } from '../../utils/utils'
import { COLOR_SCHEMES, useColorScheme } from '../../../contexts/ColorSchemeContext'

// export const useStudentThemeWithColorScheme = () => {
//   const colorScheme = useColorScheme()
//   return getStudentTheme(colorScheme === COLOR_SCHEMES.light)
// }

export const useStudentTheme = () => {
  // const colorScheme = useColorScheme()
  const { width }: { width: number } = useWindowDimensions()
  const colorScheme = useColorScheme()
  return getStudentTheme(colorScheme === COLOR_SCHEMES.light, width)
}

let getStudentTheme = (lightMode: boolean, width?: number) => {
  let studentTheme = createTheme({
    palette: {
      outlineBoxBorder: lightMode ? '#d9d9d9' : '#575861',
      background: {
        // @ts-ignore
        main: lightMode ? '#FAFAFA' : '#191A28',
        tileBackgroundColor: lightMode ? '#FFFFFF' : '#232538',
        darker: '#242532',
        gradientStart: '#333447',
        gradientEnd: '#656686',
        player: '#020101',
      },
      navigationDrawer: {
        activeTabBGColor: 'rgba(125, 137, 159, 0.25)',
        tabHoverColor: 'rgba(255, 255, 255, .05)',
        tabRippleColor: 'rgba(125, 137, 159, 0.25)',
        dividerColor: '1px solid rgba(255, 255, 255, 0.87)',

      },
      mainText: {
        main: lightMode ? '#000000' : '#FFFFFF',
        dark: 'black',
      },
      status: {
        activeHighlight: '#FDC72A',
        success: '#04BC70',
        lighterError: '#F98686',
        error: '#FF6E56',
        slightlyDarkerError: '#FF5656',
        darkerError: '#CA2626',
        inactive: '#D8D8D8'
      },
      picker: {
        selectedBackgroundColor: lightMode ? 'rgba(0, 0, 0, .2)' : 'rgba(255, 255, 255, .1)',
        hoverBackgroundColor: lightMode ? 'rgba(0, 0, 0, .1)' : 'rgba(0, 0, 0, .5)',
      },
      profile: {
        profileOptionBorderColor: '#666770'
      },
      textField: {
        backgroundColor: 'rgba(150,150,150,0.16)',
        textColor: '#555555',
        borderWidth: '0'
      },
      opaqueButton: {
        backgroundColor: lightMode ? '#76BFFE' : '#76BFFE',
        textColor: 'rgba(255, 255, 255, 0.87)',
        hoverColor: '#8ECBFE',
      },
      transparentButton: {
        borderColor: lightMode ? '#000000' : '#ffffff'
      },
      selectionPill: {
        borderColor: '#CECECE',
        active: '#DDDDDD'
      },
      lightActiveBlueColor: '#C1E0FB',
      activeBlueColor: '#76BFFE',
      darkerActiveBlueColor: '#10A5FC',
      inactiveHexagonColor: '#7c7c80',
      errorRed: '#d22323',
      playerTextColor: 'rgba(255, 255, 255, 0.87)',
      playerTextColorLine2: 'rgba(255, 255, 255, 0.7)',
      fontFamily: 'Montserrat, sans-serif',
      lessonPlayerFadeSpeed: 400,
      activeSubmitButtonShadowColor: '#10A5FC',
      inactiveGrayPlayerColor: '#979797',
      questionMultiOptionInactiveBorderColor: '#737373',
      iconBrightnessFilter: '100%',
      grayBorder: '#D8D8D8',
      grayTransparentBorder: 'rgba(216,216,216,0.35)',
      tipCardBlue: '#484866',
      copyButtonBGColor: 'rgba(216,216,216,0.38)',
      darkBlueForLink: '#3E4F89',
      classRoster: {
        titleColor: '#ffffff',
      },
      dialog: {
        backgroundColor: '#242532',
        strokeGradient: 'linear-gradient(to right, #76BFFE, #60C4C8)'
      },
      boxWithShadowBackgroundColor: '#242532',
      linkColor: '#76BFFE',
      grayTextColor: '#979797',
      lessonSummaryLabelBackgroundColor: '#ffffff',
      lessonSummaryLabelFontColor: '#000000',
      questionMultiWithImageCardBackgroundColor: '#333334',
      questionMultiOptionTextColor: 'rgba(255, 255, 255, 0.87)',
      player: {
        incorrectAnswerChoice: '#EF6863',
        incorrectFeedbackModalContinueButtonShadow: '#DF544E',
        incorrectFeedbackModalBackground: '#202121',
        correctFeedbackModalTextColor: '#000000',
        incorrectFeedbackModalTextColor: '#ffffff',
        disabledPlayerSubmitButtonFontColor: '#ffffff'
      },
      dashboardV2: {
        progressMenu: {
          progressLabelColor: lightMode ? '#EAEBED' : '#EAEBED',
          progressLabelTextColor: lightMode ? '#000000' : '#000000',
        },
        headerButton: {
          iconFillColor: '#76BFFE',
          backgroundColor: lightMode ? '#FBFBFB' : '#2C2E41',
          boxShadow: lightMode ? '0px 1px 2px 0px rgba(0,0,0,0.25)' : '',
          border: lightMode ? '0px' : '1px solid #333448',
          textColor: lightMode ? '#000' : '#FFF'
        },
        button: {
          buttonBackgroundColor: '#76BFFE',
          buttonBottomBorderColor: '#10A5FC',
          textColor: lightMode ? '#FFFFFF' : '#000000',
        },
        backButton: {
          backgroundColor: lightMode ? '#FFFFFF' : '#232538',
          hoverBackgroundColor: lightMode ? '#f3f3f3' : '#1d1e2e',
          borderColor: lightMode ? '#CECECE' : '#4E4F60',
          rippleColor: lightMode ? '#CECECE' : '#4E4F60',
        },
        progressPopup: {
          borderColor: lightMode ? 'rgba(0,0,0,0.25)' : 'rgba(255,255,255,0.25)',
          boxShadow:`0 1px 8px 2px rgba(0, 0, 0, ${lightMode ? '0.15' : '0.5'})`
        },
        content: {
          itemDescriptionTextColor: lightMode ? 'rgba(0,0,0,0.65)' : 'rgba(255,255,255,0.85)',
          itemDetailBorderColor: lightMode ? 'rgba(0,0,0,0.15)' : 'rgba(255,255,255,0.39)',
          nextUpLabelText: '#000000',
        },
        progressBar: {
          unfilledBackgroundColor: '#D8D8D8',
          unfilledInnerShadowValue: '0px 0px 2px 1px rgba(0, 0, 0, 0.25) inset',
          filledColor: '#76BFFE',
          filledBorderColor: '#47A0ED',

        },
      },
      leftTabs: {
        backgroundColor: '#232538',
        textColor: 'rgba(255,255,255,0.84)',
      },
      tileShadow: {
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.16)'
      },
      selectRoleDialog: {
        optionBoxShadow: '0 2px 3px rgba(0, 0, 0, 0.3)'
      },
      videoLibrary: {
        cardBackgroundColor: lightMode ? '#FFFFFF' : '#232538',
        playlistCountBackgroundColor: '#76BFFE',
        cardFontColor: lightMode ? '#000000' : '#FFFFFF',
        headerFontColor: lightMode ? '#000000' : '#FFFFFF',
        drilldownLockIconColor: lightMode ? '#000000' : '#FFFFFF',
        drilldownLessonDescriptionText: lightMode ? '#000000' : '#FFFFFF',
        numVideosCountColor: '#FFFFFF',
        drilldownLockColor: 'rgba(255,255,255,0.78)',
        drilldownHighlightTileLockedShadeColor: lightMode ? 'rgba(0, 0, 0, 0.4)' : 'rgba(0, 0, 0, 0.7)'
      },
      deleteAccount: {
        areYouSureBackgroundColor: lightMode ? '#FFFFFF' : '#232538',
        borderColor: lightMode ? '#000000' : '#353648',
      },
      completionPage: {
        statisticsBorderColor: lightMode ? 'rgba(0, 0, 0, .5)' : 'rgba(255, 255, 255, .5)',
        explainerFontColor: '#000000',
        pointsEarnedColor: '#FDC72A',
        courseProgressColor: '#74BBF9',
        pointsEarnedFontColor: lightMode ? '#000000' : '#FDC72A',
        courseProgressFontColor: lightMode ? '#000000' : '#74BBF9',
      },
      fourDigitValidationInput: {
        backgroundColor: lightMode ? '#F3F3F3' : '#353642',
        disabledBackgroundColor: lightMode ? '#76BFFE' : '#76BFFE',
        textColor: lightMode ? '#000000' : '#FFFFFF',
        borderColor: lightMode ? '#A0A0A0' : '#9E9E9E',
        focusedBorderColor: lightMode ? '#000000' : '#FFFFFF',
        hasValueBorderColor: lightMode ? '#76BFFE' : '#76BFFE',
      },
      optionsMenu: {
        optionDividerColor: lightMode ? 'rgba(0, 0, 0, .15)' : 'rgba(255, 255, 255, .15)',
      },
      slider: {
        selectedAreaBackgroundColor: '#76BFFE',
        unselectedAreaBackgroundColor: lightMode ? '#D8D8D8' : '#575861',
        thumbBorderColor: '#76BFFE',
        thumbBackgroundColor: lightMode ? '#fff' : '#232538',
      },
      seshDurationInput: {
        borderColor: lightMode ? '#D5D5D5' : '#575861',
        textShadow: lightMode ? 'rgba(0,0,0,0.3) 0px 1px 3px' : 'none',
        invalidInputColor: 'rgb(147,147,147)',
        helperBannerBackgroundColor: lightMode ? '#F8F8F8' : '#1E1F2E',
      },
    },
    focusPreview: {
      cardBackgroundColor: lightMode ? '#FFFFFF' : '#232538',
      cardBorder: lightMode ? '' : '2px solid #353648',
      cardBoxShadow: lightMode ? '0 1px 5px rgba(0, 0, 0, 0.16)' : '',
    },
    padding: {
      outerPadding: valuesAtBreakpoints(width)('16px', '16px', '64px')
    },
    aspectRatios: {
      'arrow-ios-right': 1,
    }
  })


  studentTheme = createTypographyFromTheme(studentTheme, width)
  return studentTheme
}

export const createTypographyFromTheme = (theme: any, width: number) => {
  return createTheme(theme, {
    typography: {
      // Nav link is a temporary type while we transition to V2.
      navLink: {
        fontSize: '15px',
        color: theme.palette.leftTabs.textColor,
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: '500',
      },
      h2: {
        fontSize: valuesAtBreakpoints(width)('35px', '42px', '42px'),
        color: theme.palette.mainText.main,
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: '600',
        letterSpacing: '1px',
      },
      h3: {
        fontSize: valuesAtBreakpoints(width)('30px', '32px', '32px'),
        color: theme.palette.mainText.main,
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: '500',
        letterSpacing: '.76px',
      },
      h4: {
        fontSize: valuesAtBreakpoints(width)('30px', '32px', '32px'),
        color: theme.palette.mainText.main,
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: '500',
        letterSpacing: '0px',
      },
      h5: {
        fontSize: valuesAtBreakpoints(width)('20px', '24px', '24px'),
        color: theme.palette.mainText.main,
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: '600',
        letterSpacing: '0.57px',
        lineHeight: 'normal',
      },
      h6: {
        fontSize: valuesAtBreakpoints(width)('16px', '18px', '18px'),
        color: theme.palette.mainText.main,
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: '500',
        letterSpacing: '0.43px',
        margin: '0px',
        lineHeight: '1.44',
      },
      subtitle1: {
        fontSize: valuesAtBreakpoints(width)('20px', '24px', '24px'),
        color: theme.palette.mainText.main,
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: '400',
        letterSpacing: '1.2px',
      },
      subtitle2: {
        fontSize: valuesAtBreakpoints(width)('20px', '22px', '22px'),
        color: theme.palette.mainText.main,
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: '400',
        letterSpacing: '1px',
      },
      body1: {
        fontSize: valuesAtBreakpoints(width)('13px', '16px', '16px'),
        color: theme.palette.mainText.main,
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: '500',
        letterSpacing: '0px',
        lineHeight: valuesAtBreakpoints(width)('1.2', '1.4', '1.4')
      },
      body2: {
        fontSize: valuesAtBreakpoints(width)('12px', '14px', '14px'),
        color: theme.palette.mainText.main,
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: '400',
        letterSpacing: '0px',
        lineHeight: 'normal',
      },
      body3: {
        fontSize: valuesAtBreakpoints(width)('10px', '12px', '12px'),
        color: theme.palette.mainText.main,
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: '300',
        letterSpacing: '0px',
        lineHeight: 'normal',
      },
      button: {
        fontSize: valuesAtBreakpoints(width)('16px', '18px', '18px'),
        color: theme.palette.mainText.main,
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: '700',
        letterSpacing: '0.81px',
      },
      overline: {
        fontSize: '10px',
        color: theme.palette.mainText.main,
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: '400',
        letterSpacing: '0px',
        textTransform: 'none',
      }
    }
  })
}

export const smallBreakpoint = 600
export const mediumBreakpoint = 900
export const largeBreakpoint = 1200
export const extraLargeBreakpoint = 1536

export const valuesAtBreakpoints = (width: number) => (
    xs: string | number,
    s: string | number,
    m: string | number,
    l: string | number | null = null,
    xl: string | number | null = null
) => {
  if (width < smallBreakpoint) return xs
  else if (width < mediumBreakpoint) return s
  else if (width < largeBreakpoint) return m
  else if (width < extraLargeBreakpoint) return coalesce(l, m)
  else return coalesce(xl, l, m)
}

export default getStudentTheme(true)
